import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Row, Col, Label } from "reactstrap";

import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Alert from "@mui/material/Alert";
import FormGroup from "@mui/material/FormGroup";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Radio from "@material-ui/core/Radio";
import InfoIcon from "@material-ui/icons/Info";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@mui/material/TextField";
import EditIcon from "@material-ui/icons/Edit";

const useStyles = makeStyles({
  list: {
    width: 450,
  },
  fullList: {
    width: "auto",
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EditJump = (props) => {
  window.sessionStorage.setItem("CredID", props.CredID);
  const [state, setState] = React.useState({
    name: "",
    description: "",
    jumphost_ip: "",
    port: "",
    credential_id: "",
    domain: "",
    os_type: "",
    errorMessage: "",
  });
  const [selectedValue, setSelectedValue] = React.useState(props.IPDNS);

  const handleChange1 = (event) => {
    setSelectedValue(event.target.value);
  };
  const [jumplist, setjumphost] = useState([]);

  const [visible, setVisible] = useState(true);

  const onDismiss = () => setVisible(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };
  const handleSubmitClick = (e) => {
    e.preventDefault();
    if (state.domain === "" && state.jumphost_ip === "") {
      const register = {
        name: state.name,
        description: state.description,
        jumphost_ip: state.jumphost_ip,
        port: state.port,
        credential_id: state.credential_id,
        os_type: state.os_type,
      };
      const JumpID = props.JumpID;
      fetch(`${process.env.REACT_APP_API_URL}/api/jumphost/${JumpID}/`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("token"),
        },
        body: JSON.stringify(register),
      })
        .then((response) => response.json())
        .then((data) => {
          window.location.reload();
        })
        .catch((error) => {
          console.error(error);
        });
    } else if (state.domain === "") {
      var pattern =
        /\b(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/;
      if (pattern.test(state.jumphost_ip)) {
        const register = {
          name: state.name,
          description: state.description,
          jumphost_ip: state.jumphost_ip,
          port: state.port,
          credential_id: state.credential_id,
          os_type: state.os_type,
        };
        const JumpID = props.JumpID;
        fetch(`${process.env.REACT_APP_API_URL}/api/jumphost/${JumpID}/`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + window.localStorage.getItem("token"),
          },
          body: JSON.stringify(register),
        })
          .then((response) => response.json())
          .then((data) => {
            window.location.reload();
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        setState({ errorMessage: "The IP Address entered is invalid!" });
      }
    } else if (state.jumphost_ip === "") {
      const isValidDomain = require("is-valid-domain");
      if (isValidDomain(state.domain)) {
        const register = {
          name: state.name,
          description: state.description,
          jumphost_ip: state.domain,
          port: state.port,
          credential_id: state.credential_id,
          os_type: state.os_type,
        };
        const JumpID = props.JumpID;
        fetch(`${process.env.REACT_APP_API_URL}/api/jumphost/${JumpID}/`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + window.localStorage.getItem("token"),
          },
          body: JSON.stringify(register),
        })
          .then((response) => response.json())
          .then((data) => {
            window.location.reload();
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        setState({
          errorMessage: "The Domain Name entered is invalid!!",
        });
      }
    }
  };

  useEffect(() => {
    const JumpID = props.JumpID;
    fetch(`${process.env.REACT_APP_API_URL}/api/jumphost/${JumpID}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          window.localStorage.setItem("user_access", data.detail);
        } else {
          setjumphost(data);
        }
      })
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, [props.CredID]);

  const [credlist, setcredlist] = useState([]);
  useEffect(() => {
    const intervalId = setInterval(() => {
      fetch(`${process.env.REACT_APP_API_URL}/api/credentiallist/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("token"),
        },
      })
        .then((resp) => resp.json())
        .then((resp) => setcredlist(resp))
        .catch((error) => {
          console.error(error);
          window.location.href = "/something_went_wrong";
        });
    }, 500);
    return () => {
      clearInterval(intervalId);
    };
  }, []);
  const [open, setOpen] = useState(false);
  const [focusAfterClose] = useState(true);
  const toggle = () => setOpen(!open);
  const isValidDomain1 = require("is-valid-domain");
  function refreshPage() {
    window.location.reload();
  }
  return (
    <>
      <IconButton
        title="Edit"
        aria-label="edit"
        id="edit"
        style={{ padding: "0px", color: "#6b6f6b" }}
      >
        <EditIcon fontSize="small" onClick={toggle} />
      </IconButton>
      <Dialog
        PaperProps={{
          sx: {
            width: "80%",
          },
        }}
        open={open}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <div>
            {state.errorMessage && (
              <Alert color="danger" isOpen={visible} toggle={onDismiss}>
                {" "}
                {state.errorMessage}{" "}
              </Alert>
            )}
          </div>
          <h2
            style={{
              textAlign: "center",
              fontSize: "18px",
              fontWeight: "810",
              color: "rgb(48, 68, 115)",
              fontFamily: "sans-serif",
              lineHeight: "4.5rem",
            }}
          >
            EDIT JUMP HOST
          </h2>

          <FormGroup style={{ marginBottom: "2rem" }}>
            <FormLabel htmlFor="name">
              <strong>Name</strong>
            </FormLabel>

            <TextField
              htmlFor="name"
              placeholder={jumplist.name}
              id="name"
              className="form-control"
              variant="outlined"
              size="small"
              fullwidth
              value={state.name}
              onChange={handleChange}
              type="text"
              name="name"
              fullWidth
            />
          </FormGroup>

          <FormGroup style={{ marginBottom: "2rem" }}>
            <FormLabel htmlFor="description">
              <strong>Description</strong>
            </FormLabel>
            <TextField
              htmlFor="description"
              placeholder={jumplist.description}
              id="description"
              className="form-control"
              variant="outlined"
              size="small"
              fullwidth
              value={state.description}
              onChange={handleChange}
              type="text"
              name="description"
              fullWidth
            />
          </FormGroup>

          <br />
          <Row>
            <Col>
              <strong>
                <Label>IP Address</Label>
              </strong>
              <Radio
                checked={selectedValue === "ipaddress"}
                onChange={handleChange1}
                value="ipaddress"
                name="radio-button-demo"
                inputProps={{ "aria-label": "C" }}
              />
              {selectedValue == "ipaddress" ? (
                <IconButton
                  color="white"
                  size="sm"
                  title="For non Jump-Host connection IP Address should be accessible over the internet"
                  data-toggle="collapse"
                >
                  <InfoIcon fontSize="small" />
                </IconButton>
              ) : (
                ""
              )}
              <strong>
                <Label>Domain name</Label>
              </strong>
              <Radio
                checked={selectedValue === "domainname"}
                onChange={handleChange1}
                value="domainname"
                name="radio-button-demo"
                inputProps={{ "aria-label": "C" }}
              />
              {selectedValue == "domainname" ? (
                <IconButton
                  color="white"
                  size="sm"
                  title="DNS should be publicly available and accessible over internet"
                  data-toggle="collapse"
                >
                  <InfoIcon fontSize="small" />
                </IconButton>
              ) : (
                ""
              )}
            </Col>
          </Row>
          {selectedValue == "domainname" ? (
            <IconButton
              color="white"
              size="sm"
              title="DNS should be publicly available and accessible over internet"
              data-toggle="collapse"
            >
              <InfoIcon fontSize="small" />
            </IconButton>
          ) : (
            ""
          )}

          <br />

          {selectedValue == "domainname" ? (
            <FormGroup style={{ marginBottom: "2.5rem" }}>
              <FormLabel htmlFor="domain" className="ml-4">
                <strong>Jumphost DNS</strong>
              </FormLabel>

              <TextField
                fullWidth
                type="text"
                id="domain"
                className="form-control"
                value={state.domain}
                onChange={handleChange}
                variant="outlined"
                size="small"
                placeholder={jumplist.jumphost_ip}
              />

              {state.domain ? (
                <p style={{ marginLeft: "24px", width: "90%" }}>
                  {" "}
                  {isValidDomain1(state.domain) ? null : (
                    <span style={{ color: "red" }}>*Invalid domain name</span>
                  )}
                </p>
              ) : (
                ""
              )}
            </FormGroup>
          ) : selectedValue == "ipaddress" ? (
            <FormGroup style={{ marginBottom: "2.5rem" }}>
              <FormLabel htmlFor="jumphost_ip" className="ml-4">
                <strong>Jumphost IP Address</strong>
              </FormLabel>
              <TextField
                fullWidth
                type="text"
                id="jumphost_ip"
                className="form-control"
                value={state.jumphost_ip}
                onChange={handleChange}
                variant="outlined"
                size="small"
                placeholder={jumplist.jumphost_ip}
                variant="outlined"
              />

              {(() => {
                if (state.jumphost_ip) {
                  return (
                    <p style={{ marginLeft: "24px", width: "90%" }}>
                      {" "}
                      {/\b(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/.test(
                        state.jumphost_ip
                      ) ? null : (
                        <span style={{ color: "red" }}>*Invalid Ipaddress</span>
                      )}
                    </p>
                  );
                }
              })()}
            </FormGroup>
          ) : (
            ""
          )}
          <FormGroup style={{ marginBottom: "2.5rem" }}>
            <FormLabel htmlFor="os_type" className="ml-4">
              <strong>OS type</strong>
            </FormLabel>

            <TextField
              className="form-control"
              type="select"
              id="os_type"
              placeholder={jumplist.os_type}
              name="os_type"
              value={state.os_type}
              onChange={handleChange}
              variant="outlined"
              size="small"
              fullWidth
              required
              select
              SelectProps={{ native: true }}
            >
              {jumplist.os_type === "windows" ? (
                <React.Fragment>
                  <option value="windows">Windows</option>
                  <option value="linux">Linux</option>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <option value="linux">Linux</option>
                  <option value="windows">Windows</option>
                </React.Fragment>
              )}
            </TextField>
          </FormGroup>

          <FormGroup style={{ marginBottom: "2.5rem" }}>
            <FormLabel htmlFor="port" className="ml-4">
              <strong>Port</strong>
            </FormLabel>

            <TextField
              placeholder={jumplist.port}
              fullWidth
              type="number"
              autoComplete="new-port"
              name="port"
              id="port"
              className="form-control"
              variant="outlined"
              size="small"
              value={state.port}
              onChange={handleChange}
            />
          </FormGroup>

          <FormGroup style={{ marginBottom: "2.5rem" }}>
            <FormLabel htmlFor="credential_id" className="ml-4">
              <strong>Credentials</strong>
            </FormLabel>

            <TextField
              className="form-control"
              type="select"
              id="credential_id"
              placeholder={jumplist.credential_id}
              name="credential_id"
              value={state.credential_id}
              onChange={handleChange}
              variant="outlined"
              size="small"
              fullWidth
              required
              select
              SelectProps={{ native: true }}
            >
              {credlist.map((credlist) => {
                if (jumplist.credential_id == credlist.id) {
                  return (
                    <React.Fragment>
                      <option value={credlist.id}>{credlist.name}</option>
                    </React.Fragment>
                  );
                }
              })}
              {credlist.map((credlist) => {
                if (jumplist.credential_id !== credlist.id) {
                  return (
                    <React.Fragment>
                      <option value={credlist.id}>{credlist.name}</option>
                    </React.Fragment>
                  );
                }
              })}
            </TextField>
          </FormGroup>
        </DialogContent>
        <DialogActions>
          <button
            className="bg-blueGray-100 text-black active:bg-blueGray-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            onClick={toggle}
          >
            Cancel
          </button>
          <button
            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            onClick={handleSubmitClick}
          >
            Update
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EditJump;